<script lang="ts">
	import { CaseStudyCategory } from "../../../core/schema/CaseStudyCategory.js";
	import { getReferencesInReferenceCategoryPath } from "../../../core/schema/paths/getReferencesInReferenceCategoryPath.js";
	import { referencesAnchorPathMap } from "../../../core/schema/paths/referencesAnchorPathMap.js";
	import type { ReferenceFilterOption } from "../../../core/schema/ReferenceFilterOption.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";

	export let filterOptions: ReferenceFilterOption[];
	export let selectedFilterOption: string | undefined;
	export let countOfAllShelfSystemReferences: number;

	const { TENANT_LOCALE } = getGlobalSettings();
</script>

<div class="relative col-span-full mt-12 flex flex-col items-center gap-4 md:mt-[25px] lg:flex-row">
	<div class="bg-gray absolute -left-[10rem] -top-6 h-[.0625rem] w-[100rem] md:hidden"></div>
	<p class="text-primary text-2xs/4 flex h-full items-start text-nowrap pt-0.5 font-extrabold md:text-xs/5">
		Filtr regálových systémů
	</p>
	<div class="flex flex-wrap items-center justify-center gap-1 lg:justify-normal">
		<a
			class="{selectedFilterOption === undefined
				? 'border-tertiary text-tertiary'
				: 'border-gray'} text-2xs/4 text-bito-black border-gray hover:text-tertiary hover:bg-mint text-nowrap border px-[.875rem] pb-[.125rem] pt-1 text-center font-bold"
			href={`/${getReferencesInReferenceCategoryPath(CaseStudyCategory.ShelfSystem, TENANT_LOCALE)}${referencesAnchorPathMap[TENANT_LOCALE]}`}
		>
			Všechny regálové systémy – {countOfAllShelfSystemReferences}
		</a>
		{#each filterOptions as filterOption}
			<a
				class="{selectedFilterOption === filterOption.id
					? 'border-tertiary text-tertiary'
					: 'border-gray'} text-2xs/4 text-bito-black border-gray hover:text-tertiary hover:bg-mint text-nowrap border px-[.875rem] pb-[.125rem] pt-1 text-center font-bold"
				href="/{filterOption.href}{referencesAnchorPathMap[TENANT_LOCALE]}"
			>
				{filterOption.name} – {filterOption.counter}
			</a>
		{/each}
	</div>
</div>
